import { render, staticRenderFns } from "./EventPageContent.vue?vue&type=template&id=4822a6f1&scoped=true&"
import script from "./EventPageContent.vue?vue&type=script&lang=js&"
export * from "./EventPageContent.vue?vue&type=script&lang=js&"
import style0 from "./EventPageContent.vue?vue&type=style&index=0&id=4822a6f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4822a6f1",
  null
  
)

export default component.exports